angular.module('bmsApp.accounting').controller('InvoiceIndexCustomerMMInvoicesCtrl', function ($scope) {
	$scope.customerInvoices = [];
	angular.forEach($scope.customer.mm_jobs, (job) => {
		angular.forEach(job.job_parts, (jobPart) => {
			angular.forEach(jobPart.invoices, (invoice) => {
				$scope.customerInvoices.push(invoice);
			});
		});
	});
});
